import {
  ResourceBar,
  type ResourceBarProps,
} from "@thilke/ui/components/resource-bar";

function ManaBar(props: ResourceBarProps) {
  return <ResourceBar {...props} indicatorClassName="bg-primary" />;
}

export default ManaBar;
export { ManaBar };
